var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-notsupport"},[_c('small',[_vm._v("当前设备信息："),_c('br'),_vm._v(_vm._s(_vm.ua))])])
}
var staticRenderFns = []

export { render, staticRenderFns }